export const SELECTED_ROW_SELECTOR = '[data-selected="true"], [aria-selected="true"]';

/** Pure: scrollTop that centres a row inside its scroll container (clamped). */
export function centeredScrollTop({ itemTop, itemHeight, clientHeight, scrollHeight }) {
  const maxTop = Math.max(0, scrollHeight - clientHeight);
  const target = itemTop - clientHeight / 2 + itemHeight / 2;
  return Math.max(0, Math.min(maxTop, target));
}

/** Row offset relative to the container's scroll origin. */
export function offsetTopWithin(item, container) {
  return item.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
}

/**
 * Scrolls `container` (not the page) so the first row matching `selector` is
 * centred. No-op when nothing is selected or the list does not overflow.
 * Returns true when it scrolled.
 */
export function scrollSelectedIntoView(container, selector = SELECTED_ROW_SELECTOR) {
  if (!container) return false;
  const item = container.querySelector(selector);
  if (!item) return false;
  if (container.scrollHeight <= container.clientHeight) return false;
  container.scrollTop = centeredScrollTop({
    itemTop: offsetTopWithin(item, container),
    itemHeight: item.offsetHeight,
    clientHeight: container.clientHeight,
    scrollHeight: container.scrollHeight,
  });
  return true;
}
